import {
  Table,
  Container,
  Button,
  SpaceBetween,
  Header,
  Box,
  ContentLayout,
  ExpandableSection,
  Select,
  TableProps,
  Textarea,
  ColumnLayout,
  Link
} from '@cloudscape-design/components';

// context
import { DocumentContext } from '../../context/documentContext';
import { useContext, useEffect, useState } from 'react';

// const evidences = [
//   { name: 'evidence 1' },
//   { name: 'evidence 2' },
//   { name: 'evidence 3' }
// ];
export const ViewerSidePanel = () => {
  const {
    selectedControlOptions,
    selectedDomainOption,
    domains,
    controls,
    setKnowledgeBaseModal,
    setShowModal,
    getCurrentSentenceKB,
    selectedItems,
    setSelectedItemsKbResults,
    setKbLoading
  } = useContext(DocumentContext);
  const [controlDescription, setControlDescription] = useState<string>('');
  const [domainDescription, setDomainDescription] = useState<string>('');
  const [controlStatus, setControlsStatus] = useState<string>('');
  const [owner, setOwner] = useState<string>('');

  useEffect(() => {
    if (!selectedDomainOption?.label) return;
    if (selectedDomainOption.label !== '') {
      const [descDomain] = domains.filter(
        (ele) => ele.domainName.trim() === selectedDomainOption.label?.trim()
      );
      if (descDomain) {
        setDomainDescription(descDomain.domainDescription);
      }
    } else {
      setDomainDescription('');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDomainOption]);
  useEffect(() => {
    if (!selectedControlOptions?.label) return;
    if (selectedControlOptions.label !== '') {
      const [descControl] = controls.filter(
        (ele) => ele.controlName.trim() === selectedControlOptions.label?.trim()
      );
      if (descControl) {
        setControlDescription(descControl.controlDescription);
        setControlsStatus(descControl.controlStatus);
        setOwner(descControl.controlOwners);
      }
    } else {
      setControlDescription('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedControlOptions]);
  const handleKnowledgeBaseModal = () => {
    if (selectedItems[0].kbSentences.length > 0) {
      console.log('setting current kb items');
      setSelectedItemsKbResults(selectedItems[0].kbSentences);
      setKbLoading(false);
    } else {
      getCurrentSentenceKB();
    }
    setShowModal(true);
    setKnowledgeBaseModal(true);
  };

  return (
    <Container header={<Header variant="h2">{`Knowledge Mapping`}</Header>}>
      <SpaceBetween direction="vertical" size="xl">
        <Container header={<Header>General Response</Header>}>
          <div style={{ overflowY: 'scroll', height: '20vh' }}>
            {domainDescription
              ? domainDescription
              : 'This is the high-level topic of the compliance content discovered by Koru. Koru has also provided a summary of the content from your Koru Knowledge Base which was generated from your organization’s compliance content (policies, procedures, wikis, etc.)'}
          </div>
        </Container>
        <Container
          header={
            // <SpaceBetween size={'s'}>
            <>
              <h3 style={{margin: "0.1%, 0.1%"}}>Detailed Response</h3>
              <h6 style={{ paddingTop: '0.10%', marginTop: '0.1%', marginBottom: "0.5%" }}>
                {owner}
              </h6>
              </>
            // </SpaceBetween>
          }
        >
          {/* <SpaceBetween direction="vertical" size="s"> */}
            <div style={{ overflowY: 'scroll',height: '35vh' }}>
              {controlDescription
                ? controlDescription
                : 'This is  specific information about the topic for the discovered compliance content predicted by Koru. Koru has also retrieved summarized information from the Koru Knowledge Base which was generated from your organizational documents (Artifacts such as a policy, or other organizational documentation). Use these citations to find relevant documentation to use as supporting materials, or provide you with more context while developing a detailed response or evaluate  compliance impact. Any detailed responses you create and decide to store in your Knowledge Base will be available for future reference to improve consistency in future responses.'}
            </div>

            <Link>source_document.pdf</Link>
          {/* </SpaceBetween> */}
        </Container>
        <Button
          disabled={!(selectedItems.length > 0)}
          onClick={() => handleKnowledgeBaseModal()}
        >
          Knowledge Base
        </Button>
      </SpaceBetween>
    </Container>
  );
};
